import Vue from "vue";

import "./styles/quasar.styl";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/ionicons-v4/ionicons-v4.css";
import {
  Quasar,
  QCheckbox,
  Notify,
  QLayout,
  QPageContainer,
  QPage,
  QBtn,
  QIcon,
  QFooter,
  QImg,
  QCard,
  QCardSection,
  QCardActions,
  QTooltip,
  QForm,
  QInput,
  QDialog,
  ClosePopup,
  Loading,
  QSeparator,
  Dialog,
  QSpace,
  QBtnDropdown,
  QBanner,
  Ripple,
  QPopupProxy,
  QDate,
  QSelect,
  QList,
  QItem,
  QItemSection,
  QItemLabel
} from "quasar";

Vue.use(Quasar, {
  config: {
    loading: {}
  },
  components: {
    QLayout,
    QCheckbox,
    QPageContainer,
    QPage,
    QBtn,
    QIcon,
    QFooter,
    QImg,
    QTooltip,
    QCard,
    QCardSection,
    QCardActions,
    QForm,
    QInput,
    Notify,
    QDialog,
    ClosePopup,
    QSeparator,
    QSpace,
    QBtnDropdown,
    QBanner,
    QPopupProxy,
    QDate,
    QSelect,
    QList,
    QItem,
    QItemSection,
    QItemLabel
  },
  directives: {
    Ripple,
    ClosePopup
  },
  plugins: {
    Notify,
    Loading,
    Dialog
  }
});
